var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.654 473.654",
    style: {
      enableBackground: "new 0 0 473.654 473.654"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EDC92C"
    },
    cx: 236.827,
    cy: 236.827,
    r: 236.827
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B4A4B"
    },
    d: "M413.313,228.394c-83.628-101.956-170.596-97.771-174.81-97.491 c-4.244-0.277-91.182-4.461-174.818,97.491c0.856-0.856-5.871,6.825-5.609,16.42l0,0c0,0,0,0,0,0.03 c-0.262,9.57,6.466,17.232,5.609,16.383c83.636,101.956,170.573,97.771,174.818,97.506c4.214,0.262,91.182,4.446,174.81-97.506 c-0.849,0.853,5.871-6.813,5.609-16.383c0-0.03,0-0.03,0-0.03l0,0C419.188,235.219,412.468,227.542,413.313,228.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M396.114,230.014c-75.405-91.922-153.812-88.153-157.612-87.899 c-3.826-0.251-82.203-4.024-157.608,87.899c0.767-0.77-5.295,6.155-5.063,14.801l0,0c0,0,0,0,0,0.026 c-0.236,8.631,5.83,15.538,5.063,14.771c75.405,91.922,153.782,88.149,157.608,87.914c3.799,0.236,82.203,4.009,157.608-87.914 c-0.767,0.767,5.295-6.144,5.056-14.771c0-0.026,0-0.026,0-0.026l0,0C401.41,236.165,395.348,229.243,396.114,230.014z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1F92D0"
    },
    cx: 239.968,
    cy: 245.391,
    r: 82.271
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#36A5DD"
    },
    cx: 239.968,
    cy: 245.391,
    r: 74.791
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B4A4B"
    },
    cx: 239.968,
    cy: 245.391,
    r: 54.224
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 261.471,
    cy: 222.019,
    r: 22.793
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.13edde4a40e842cd107da28b5d2c3b25.svg";
export { ForwardRef as ReactComponent };